
import React from 'react';
import { Button } from "@/components/ui/button";
import { Link } from 'react-router-dom';
import { useAuth } from '@/contexts/auth-context';
import MobileMenuButton from './MobileMenuButton';
import MobileNavLinks from './MobileNavLinks';
import Logo from './Logo';

const MobileNav: React.FC = () => {
  const [isOpen, setIsOpen] = React.useState(false);
  const { user, logout } = useAuth();

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);
  
  const handleLogout = async () => {
    try {
      await logout();
      closeMenu();
    } catch (error) {
      console.error('Logout failed:', error);
    }
  };

  return (
    <div className="md:hidden">
      <div className="flex items-center justify-between py-3 px-4">
        <Link to="/" onClick={closeMenu}>
          <Logo textSize="text-xl" linkTo={false} />
        </Link>
        
        <div className="flex items-center gap-2">
          {!user && (
            <Link to="/login">
              <Button size="sm" variant="outline" className="h-8">Sign In</Button>
            </Link>
          )}
          <MobileMenuButton isOpen={isOpen} onClick={toggleMenu} />
        </div>
      </div>
      
      {isOpen && (
        <div className="px-4 pb-4 border-t border-gray-100">
          <MobileNavLinks 
            user={user} 
            onLinkClick={closeMenu}
            onLogout={handleLogout}
          />
        </div>
      )}
    </div>
  );
};

export default MobileNav;
